import React, { useState, useEffect } from "react";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import moreIcon from "../../assets/images/DeathModuleNew/Menu.png";
import swal from "sweetalert";
import List from "../styledComponents/Table/List";
import { saveAs } from "file-saver";

export const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const getSelectedRow = (idx) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
  };

  const cols = [
    {
      title: "Due date",
      dataIndex: "dueDate",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (record) => (record ? "$" + record : "$0"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            {" "}
            <img
              style={{ cursor: "pointer", marginLeft: "1rem" }}
              src={moreIcon}
              alt="moreIcon"
              onClick={() => {
                console.log("recode", record.invoiceId);
                setDropdown(!dropdown);
                getSelectedRow(record.invoiceId);
              }}
            ></img>{" "}
            {dropdown && selectedIndex === record.invoiceId && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        downloadSingle(record.invoiceId);
                        setDropdown(false);
                      }}
                    >
                      View Invoice
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getInvoices = async () => {
    try {
      setLoading(true);
      let obj = [];
      let data = await DEATH_API.getInvoices();
      console.log("data cards 22", data.data);
      if (data && data.data) {
        setInvoices(data.data);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const downloadSingle = async (id) => {
    try {
      setLoading(true);
      let datares = await DEATH_API.downloadInvoice({ invoiceId: id });
      console.log("datares", datares);
      if (datares && datares.status === 200) {
        const customFileName = "invoice.pdf";
        const downloadLink = document.createElement("a");
        downloadLink.href = datares.data;
        downloadLink.download = customFileName;
        downloadLink.target = "_blank"; // Opens in a new tab, remove if not needed
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        swal("Success", datares.message, "success");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const downloadAll = async () => {
    try {
      setLoading(true);
      let datares = await DEATH_API.downloadAllInvoices();
      console.log("datares", datares);
      if (datares && datares.status === 200) {
        const customFileName = "invoices.pdf";
        const downloadLink = document.createElement("a");
        downloadLink.href = datares.data[0].pdf;
        downloadLink.download = customFileName;
        downloadLink.target = "_blank"; // Opens in a new tab, remove if not needed
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        swal("Success", datares.message, "success");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    getInvoices();
  }, []);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1
          style={{
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Invoices
        </h1>
        <button
          className="savebutton"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
            width: "150px",
          }}
          type="submit"
          onClick={downloadAll}
        >
          Download
        </button>
      </div>
      <div className="rolesTable" style={{ marginTop: "10px" }}>
        <div className="RolesHeader">
          <div className="RoleTitle">Invoices</div>
        </div>
        <List cols={cols} rows={invoices} />
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
